(function () {
  var drawer  = document.getElementById('Look-Drawer');
  var content = document.getElementById('Look-Drawer-Content');
  var cc      = document.querySelector('.click-capture--look');
  var body    = document.body;

  if (!drawer || !content) return;

  /* ── helpers ── */
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function sizedImg(src, size) {
    return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_' + size + '$1$3');
  }

  /* ── complementary recommendations ── */
  function getComplementaryEl() {
    return document.querySelector('product-recommendations[data-url*="intent=complementary"]')
      || document.querySelector('.complementary-products product-recommendations')
      || document.querySelector('product-recommendations');
  }

  function getHandlesFromDom() {
    var recoEl = getComplementaryEl();
    var handles = [];
    if (recoEl) {
      recoEl.querySelectorAll('quick-view[data-product-handle]').forEach(function (qv) {
        if (qv.dataset.productHandle) handles.push(qv.dataset.productHandle);
      });
    }
    return handles;
  }

  function fetchHandles(callback) {
    var handles = getHandlesFromDom();
    if (handles.length) { callback(handles); return; }

    /* recommendations not yet loaded — wait up to 4 s */
    var recoEl = getComplementaryEl();
    if (!recoEl) { callback([]); return; }

    var timeout;
    var observer = new MutationObserver(function () {
      var h = getHandlesFromDom();
      if (h.length) {
        observer.disconnect();
        clearTimeout(timeout);
        callback(h);
      }
    });
    observer.observe(recoEl, { childList: true, subtree: true });
    timeout = setTimeout(function () {
      observer.disconnect();
      callback(getHandlesFromDom());
    }, 4000);
  }

  /* ── capture selected options from main product page ── */
  function captureMainOptions() {
    var opts = {};
    var vs = document.querySelector('variant-selects:not(#Product-Drawer variant-selects):not(#Look-Drawer variant-selects)');
    if (!vs) return opts;
    vs.querySelectorAll('input[type=radio]:checked').forEach(function (input) {
      var name = input.name.replace(/--sticky$/, '');
      opts[name] = input.value;
    });
    vs.querySelectorAll('select').forEach(function (sel) {
      var m = sel.name.match(/^options\[(.+?)(?:--sticky)?\]$/);
      if (m) opts[m[1]] = sel.value;
    });
    return opts;
  }

  /* ── find best matching variant for given options ── */
  function bestVariant(variants, selectedOptions) {
    if (!Object.keys(selectedOptions).length) return null;
    /* try exact match on option1 (Taille) first */
    var keys = Object.keys(selectedOptions);
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = keys.some(function (k) {
        return v.option1 === selectedOptions[k]
          || v.option2 === selectedOptions[k]
          || v.option3 === selectedOptions[k];
      });
      if (match && v.available) return v;
    }
    /* fallback: unavailable variant still pre-selects visually */
    for (var j = 0; j < variants.length; j++) {
      var vj = variants[j];
      var matchJ = keys.some(function (k) {
        return vj.option1 === selectedOptions[k]
          || vj.option2 === selectedOptions[k]
          || vj.option3 === selectedOptions[k];
      });
      if (matchJ) return vj;
    }
    return null;
  }

  /* ── open / close ── */
  function openDrawer(productId, limit, label) {
    if (label) drawer.querySelector('.look-drawer-title').textContent = label;
    body.classList.add('open-cc--look', 'overflow-hidden');
    drawer.classList.add('active');
    drawer.removeAttribute('inert');
    drawer.removeAttribute('aria-hidden');
    drawer.focus();

    var mainOptions = captureMainOptions();
    content.innerHTML = '<div class="look-drawer-loading"><span></span><span></span><span></span></div>';

    fetchHandles(function (handles) {
      if (!handles.length) {
        content.innerHTML = '<p class="look-drawer-empty">' + window.theme.lookDrawer.noProducts + '</p>';
        return;
      }
      Promise.all(handles.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        });
      }))
        .then(function (products) {
          content.innerHTML = products.map(function (p) { return renderProduct(p, mainOptions); }).join('');
          bindAddToCart();
        })
        .catch(function (err) {
          console.error('[look-drawer] fetch error', err);
          content.innerHTML = '<p class="look-drawer-empty">' + window.theme.lookDrawer.fetchError + '</p>';
        });
    });
  }

  function closeDrawer() {
    body.classList.remove('open-cc--look', 'overflow-hidden');
    drawer.classList.remove('active');
    drawer.setAttribute('inert', '');
    drawer.setAttribute('aria-hidden', 'true');
  }

  /* ── render one product ── */
  function renderProduct(p, mainOptions) {
    /* /products/handle.js returns images as URL strings, not objects */
    var rawImg = p.images && p.images.length ? p.images[p.images.length - 1] : null;
    var imgSrc = rawImg ? (typeof rawImg === 'string' ? rawImg : rawImg.src) : null;
    var img = imgSrc
      ? '<img src="' + sizedImg(imgSrc, '300x') + '" alt="' + escAttr(p.title) + '" loading="lazy" width="150" height="188">'
      : '';

    var price = p.price_min || p.price || 0;
    var isDefault = p.variants.length === 1 && p.variants[0].title === 'Default Title';
    var variantHtml;

    if (isDefault) {
      variantHtml = '<input type="hidden" class="look-product--vid" value="' + p.variants[0].id + '">';
    } else {
      var preselected = bestVariant(p.variants, mainOptions || {});
      var preselectedId = preselected ? preselected.id : null;
      var opts = p.variants.map(function (v) {
        var sel = (preselectedId && v.id === preselectedId) ? ' selected' : '';
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + sel + '>' + escAttr(v.title) + '</option>';
      }).join('');
      variantHtml = '<div class="look-product--select-wrap"><select class="look-product--vid">' + opts + '</select></div>';
    }

    var url = p.url || ('/products/' + p.handle);

    return '<div class="look-product">'
      + '<a href="' + url + '" class="look-product--image" tabindex="-1">' + img + '</a>'
      + '<div class="look-product--info">'
      +   '<a href="' + url + '" class="look-product--title">' + escHtml(p.title) + '</a>'
      +   '<div class="look-product--price">' + formatMoney(price) + '</div>'
      +   variantHtml
      +   '<button class="look-product--add button full" type="button">' + window.theme.lookDrawer.add + '</button>'
      + '</div>'
      + '</div>';
  }

  function escAttr(s) { return String(s).replace(/"/g, '&quot;'); }
  function escHtml(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  /* ── add to cart ── */
  function bindAddToCart() {
    content.querySelectorAll('.look-product--add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.look-product');
        var vidEl = wrap.querySelector('.look-product--vid');
        var variantId = vidEl ? (vidEl.tagName === 'SELECT' ? vidEl.value : vidEl.value) : null;
        if (!variantId) return;

        btn.classList.add('loading');
        btn.disabled = true;

        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', 1);

        fetch(window.theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
          body: fd
        })
          .then(function (r) { return r.json(); })
          .then(function (resp) {
            if (resp.status) {
              btn.textContent = resp.description || 'Indisponible';
              btn.disabled = false;
              btn.classList.remove('loading');
              return;
            }

            document.dispatchEvent(new CustomEvent('cart:refresh'));

            btn.textContent = window.theme.lookDrawer.added;
            if (typeof dispatchCustomEvent === 'function') {
              dispatchCustomEvent('cart:item-added', {
                product: resp.hasOwnProperty('items') ? resp.items[0] : resp
              });
            }
          })
          .catch(function () {
            btn.textContent = window.theme.lookDrawer.error;
            btn.disabled = false;
            btn.classList.remove('loading');
            setTimeout(function () { btn.textContent = window.theme.lookDrawer.add; }, 2000);
          });
      });
    });
  }

  /* ── event listeners ── */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.look-drawer-trigger');
    if (trigger) {
      openDrawer(
        trigger.dataset.productId,
        trigger.dataset.limit || 10,
        trigger.textContent.trim()
      );
      return;
    }
    if (e.target.closest('.look-drawer-close') || e.target === cc) {
      closeDrawer();
    }
  });

  if (cc) cc.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('active')) closeDrawer();
  });
})();
